import axios from '../../axios/index.js'

export default {
    list(data) {
        return axios.get('entries/list', { params: data })
    },
    show(id) {
        return axios.get('entries/show/' + id)
    },
    getContainers(id) {
        return axios.get('entries/get_containers/' + id)
    },
    getReviewOrder(id) {
        return axios.get('entries/get_review_order/' + id)
    },
    getInvoiceList(id) {
        return axios.get('entries/get_invoices_list/' + id)
    },
    getLoadOrder(id) {
        return axios.get('entries/get_load_order/' + id)
    },
    getFiles(id) {
        return axios.get('entries/get_entry_files/' + id)
    },
    getBarPlotDate(client_id) {
        return axios.get('entries/barPlotData/'+ client_id)
    },
    getFirstDonut(filter) {
        return axios.get('entries/donut/'+filter)
    },
    averageAgingDonut(filter){
        return axios.get('entries/average_aging_donut/'+filter)
    },
    warehouseCapacityDonut(){
        return axios.get('entries/warehouse_donut')
    },
    timeline(entry_id){
        return axios.get('entries/timeline/'+entry_id)
    },
    addComment(data) {
      return axios.post('entries/addComment',data,{ headers:{ 'Content-Type': 'multipart/form-data' }, processData:false, contentType:false })
    },
    setInventary(data) {
      return axios.post('entries/set_inventary',data)
    },
    setLock(data) {
      return axios.post('entries/set_lock',data)
    },
    getContainerTypes() {
        return axios.get('/entries/containerTypes')
    },
    updateContainer(data) {
      return axios.post('entries/updateContainer',data)
    },
    update(data){
        return axios.post('entries/update',data) 
    },
    getProviders(){
        return axios.get('/entries/getProviders')
    },
    getStatusList(){
        return axios.get('/entries/getStatusList')
    },
    getSignature(id){
        return axios.get('entries/willcall/' + id)
    }
}
